/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import Card from '@mui/material/Card';
import { InputText } from "primereact/inputtext";
import { Button, Alert } from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { Hidden, makeStyles } from "@material-ui/core";
import { useNavigate } from 'react-router-dom';
import LoadingComponent from '../lib/LoadingComponent';
import FadeIn from 'react-fade-in'
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import { RemoveScrollBar } from 'react-remove-scroll-bar';
import { useDispatch, useSelector } from 'react-redux';
import Cookie from '../lib/Cookie';
import { setAuthen, setRoles } from '../libs/todoSlice';
import fontColor from '../lib/fontColor';
import {
  getPrefixFeedbackRedux, setPrefixFeedbackRedux, getBusinessesRedux, setBusinessesRedux, getBusinessRedux, setBusinessRedux,
  getEmailRedux, setEmailRedux, getPrefixRedux, setPrefixRedux, getLoadingRedux, setLoadingRedux, getDuplicatedRedux, setDuplicatedRedux
} from '../libs/createPathSlice'
import { logoutSession } from '../lib/logoutRedirect';
import Swal from 'sweetalert2';


const CreatePath = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  // const [ prefixFeedback, setPrefixFeedback ] = useState('')
  // const [ businesses, setBusinesses ] = useState([])
  // const [ business, setBusiness ] = useState('')
  // const [ email, setEmail ] = useState('')
  // const [ prefix, setPrefix ] = useState('')
  // const [ loading, setLoading ] = useState(false)
  // const [ duplicated, setDuplicated ] = useState(null)
  const [cookie, setCookie, removeCookie] = useCookies(['account'])
  const [bizAutoSelect, setBizAutoSelect] = useState("")
  const [serviceList, setServiceList] = useState([])

  const prefixRef = useRef()

  const prefixFeedback = useSelector(getPrefixFeedbackRedux)
  const setPrefixFeedback = (action) => {
    dispatch(setPrefixFeedbackRedux({
      prefixFeedback: action
    }))
  }

  const businesses = useSelector(getBusinessesRedux)
  const setBusinesses = (action) => {
    dispatch(setBusinessesRedux({
      businesses: action
    }))
  }

  const business = useSelector(getBusinessRedux)
  const setBusiness = (action) => {
    dispatch(setBusinessRedux({
      business: action
    }))
  }

  const email = useSelector(getEmailRedux)
  const setEmail = (action) => {
    dispatch(setEmailRedux({
      email: action
    }))
  }

  const prefix = useSelector(getPrefixRedux)
  const setPrefix = (action) => {
    dispatch(setPrefixRedux({
      prefix: action
    }))
  }

  const loading = useSelector(getLoadingRedux)
  const setLoading = (action) => {
    dispatch(setLoadingRedux({
      loading: action
    }))
  }

  const duplicated = useSelector(getDuplicatedRedux)
  const setDuplicated = (action) => {
    dispatch(setDuplicatedRedux({
      duplicated: action
    }))
  }


  const getBusinesses = async () => {
    setLoading(true)
    try {
      const { data } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra`,
        withCredentials: true,
      })
      setBusinesses(data.data.map(biz => {
        biz.biz_name = `${biz.biz_name} (${biz.branch_name ?? `ไม่มีชื่อสาขา`})`
        return biz
      }))
      setLoading(false)
    } catch ({ response }) {
      const status = response?.status
      setLoading(false)

      if (status === 401) {
        localStorage.removeItem('account')
        return
      }

      if (status === 403) {
        navigate('/forbidden')
      }
    }
  }

  const checkDuplicatePrefix = async (input) => {
    setPrefixFeedback({})
    if (input.length !== 0) {
      try {
        const { data, status } = await axios({
          method: 'GET',
          url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/prefix/duplicated?prefix=${input}`,
        })
        setDuplicated(data.data.duplicated)
        if (data.data.duplicated === true) {
          setPrefixFeedback({
            message: 'Path ซ้ำ กรุณาเปลี่ยน path',
            color: 'error'
          })
        } else {
          setPrefixFeedback({})
        }
      } catch ({ response }) {

      }
    } else {
      setDuplicated(null)
    }
  }

  useEffect(() => {
    getBusinesses()
    setEmail(JSON.parse(localStorage.getItem('account')).thai_email)
    if(localStorage.getItem('set_service_biz') && localStorage.getItem('set_service_biz')){
    setBizAutoSelect(JSON.parse(localStorage.getItem('set_service_biz')).biz_id)
    setServiceList(JSON.parse(localStorage.getItem('set_service_biz')).service)
  }
  }, [])

  useEffect(() => {
    if (!localStorage.getItem('account')) {
      navigate('/')
    }
  })

  useEffect(() => {
    document.body.classList.add('create-path');
    return () => {
      document.body.classList.remove('create-path');
    }
  })

  const logout = async () => {
    await logoutSession({
      removeCookie,
      dispatch,
      oauth: cookie.oauth,
      prefix: '',
    })
  };

  useEffect(() => {
    if (bizAutoSelect && businesses.length > 0) {
      const biz = businesses.find(b => b.biz_id === bizAutoSelect);
      if (biz) setBusiness(biz.biz_id);
    }
  }, [bizAutoSelect, businesses]);

  return (
    <div
      style={{
        background: '#F8F9FA',
        height: '100vh'
      }}
    >
      <RemoveScrollBar />
      <div style={{ padding: '30px 80px 0 80px' }}>
        <img
          src="/one-platform.png"
          alt=""
          style={{
            maxHeight: '60px',
            maxWidth: '60px',
            // boxShadow: '2px 2px 6px',
            // borderRadius: '5px'
          }}
          onError={({ target }) => {
            target.src = '/one-platform.png'
          }}
        />
        <span
          style={{
            fontWeight: '600',
            color: '#053075',
            padding: '10px',
          }}
        >
          One Platform
        </span>
        <span
          style={{
            float: 'right',
          }}
        >
          <Button
            onClick={() => {
              logout()
            }}
            sx={{
              color: fontColor('#053075'),
              justifyContent: 'center',
              alignItems: 'center',
              padding: '9px 15px',
              gap: '10px',
              width: '120px',
              height: '36px',
              background: '#053075',
              borderRadius: '6px',
              float: 'right',
            }}
          >
            ออกจากระบบ
          </Button>
        </span>
      </div>
      <Hidden xsDown>
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <img
            src="/img_create_path.png"
            style={{
              position: 'fixed',
              width: '670.75px',
              height: '650.54px',
              top: '110px',
            }}
            alt=''
          />
        </div>
      </Hidden> 
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '60px 40px',
          gap: '36px',
        }}
      >
        <Card
          style={{
            width: '467px',
            background: 'rgba(0, 0, 0, 0.2)',
            borderRadius: '32px',
            padding: '40px 40px',
            zIndex: '1'
          }}
        >
          <div className="col-12 text-center" style={{ paddingBottom: '30px' }}>
            <span
              style={{
                fontSize: '34px',
                color: '#053075',
              }}
            >
              <b>ยินดีต้อนรับเข้าสู่ระบบ UM</b>
            </span>
          </div>
          {loading ?
            <LoadingComponent />
            :
            <div className="flex flex-column gap-2" style={{ paddingBottom: '15px' }}>
              <div style={{ display: 'flex', paddingBottom: '5px' }}>
                <label htmlFor="businesses" style={{ color: '#053075' }}>เลือกนิติบุคคลที่ต้องการจัดการ</label>
              </div>
              <Autocomplete
                value={businesses.find(b => b.biz_id === business) || null}
                onChange={(e, value) => {
                  setBusiness(value.biz_id)
                  setPrefix('')
                }}
                options={businesses}
                getOptionLabel={(option) => option.biz_name ?? option}
                isOptionEqualToValue={(option, value) => {
                  return option.biz_id === value.biz_id
                }}
                renderInput={(params, key) =>
                  <TextField {...params}
                    size='small'
                    key={key}
                    className='autocomplete-input-h-0'
                    sx={{
                      height: '0px !important'
                    }}
                    style={{
                      height: '0px !important'
                    }}
                    placeholder="โปรดเลือกนิติบุคคลที่ต้องการจัดการ"
                  />
                }
                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option.biz_id}>
                      {option.biz_name}
                    </li>
                  );
                }}
                disableClearable
                className="w-full md:w-14rem"
                style={{
                  background: '#FFFFFF',
                  border: '1px solid #EEEEEE',
                  borderRadius: '6px',
                  width: '387px',
                  height: '36px',
                }}
              />
            </div>
          }
          {(business && businesses.filter(b => b.biz_id === business && !b.prefix).length !== 0) &&
            <>
              <div className="flex flex-column gap-2" style={{ paddingBottom: '15px' }}>
                <div style={{ display: 'flex', paddingBottom: '5px' }}>
                  <label htmlFor="username" style={{ color: '#053075' }}>เพิ่มผู้ดูแลส่วนระบบนี้</label>
                </div>
                <InputText
                  placeholder="กรอกอีเมลที่ใช้ในการเข้าสู่ระบบ"
                  value={email}
                  disabled
                  style={{
                    background: '#FFFFFF',
                    border: '1px solid #EEEEEE',
                    borderRadius: '6px',
                    width: '387px',
                    height: '36px',
                  }}
                />
              </div>
              {business &&
                <>
                  <div className="flex flex-column gap-2" style={{ paddingBottom: '30px' }}>
                    <div style={{ display: 'flex', paddingBottom: '5px' }}>
                      <label htmlFor="username" style={{ color: '#053075' }}>ตั้งค่า Path การเข้าถึง</label>
                      <HelpOutlineOutlinedIcon
                        style={{
                          color: '#053075',
                          fontSize: 'large',
                          alignSelf: 'center',
                          marginLeft: '5px'
                        }}
                      />
                    </div>
                    <div className="input-box">
                      <InputText
                        style={{
                          background: '#FFFFFF',
                          border: '1px solid #EEEEEE',
                          borderRadius: '6px',
                          width: '387px',
                          height: '36px',
                          paddingLeft: '126px'
                        }}
                        value={prefix}
                        autoFocus
                        onKeyDown={(e) => {
                          if (e.key === '/') {
                            e.preventDefault()
                          }
                        }}
                        onChange={(e) => {
                          if (/^[a-zA-Z0-9-]+$/.test(e.target.value) || e.target.value === '') {
                            Promise.resolve(setPrefix(e.target.value)).then(() => {
                              checkDuplicatePrefix(e.target.value)
                            })
                          }
                          // if (e.target.value === "businesses" || e.target.value === "business" || e.target.value === "api" || e.target.value === "login" || e.target.value === "admin") {
                          //   Swal.fire({
                          //     icon: 'error',
                          //     title: 'แจ้งเตือน',
                          //     text: 'ขอสงวนสิทธิ์ในการใช้คำดังกล่าว',
                          //   })
                          //   setPrefix('')
                          // }
                        }}
                      />
                      <span className="text-input">https://um.id.th/</span>
                    </div>
                    {(prefix === 'businesses' ||
                      prefix === 'business' ||
                      prefix === 'api' ||
                      prefix === 'login' ||
                      prefix === 'admin') && (
                        <div style={{ color: 'red', margin: 10, marginBottom: 0 }}>กรุณาตั้งชื่อใหม่</div>
                      )}
                  </div>
                  {prefixFeedback && prefixFeedback.message &&
                    <FadeIn>
                      <div style={{ paddingBottom: '30px' }}>
                        <Alert variant="filled" severity={prefixFeedback.color}>
                          {prefixFeedback.message}
                        </Alert>
                      </div>
                    </FadeIn>
                  }
                  {
                    business && (
                      <Button
                        style={{
                          width: '387px',
                          height: '36px',
                          background: '#F6911F',
                          borderRadius: '6px',
                          color: 'white'
                        }}
                        disabled={
                          business.length === 0 ||
                          email.length === 0 ||
                          prefix.length === 0 ||
                          duplicated === true ||
                          duplicated === null ||
                          prefix === 'businesses' ||
                          prefix === 'business' ||
                          prefix === 'api' ||
                          prefix === 'login' ||
                          prefix === 'admin'
                        }
                        onClick={() => {
                          navigate(`/theme_color?biz_id=${business}&prefix=${prefix}&service=${serviceList}`)
                        }}
                      >
                        ดำเนินการสร้าง
                      </Button>
                    )
                  }
                </>
              }
            </>
          }
          {(business && businesses.filter(b => b.biz_id === business && b.prefix).length !== 0) &&
            <Button
              style={{
                width: '387px',
                height: '36px',
                background: '#F6911F',
                borderRadius: '6px',
                color: 'white'
              }}
              onClick={() => {
                const selected = businesses.filter(b => b.biz_id === business && b.prefix)[0]
                const target = `/${selected.prefix}/manage-members`
                navigate(target)
              }}
            >
              เข้าสู่เว็บไซต์
            </Button>
          }
        </Card>
      </div> 
    </div>
  )
}

export default CreatePath